"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M12.7015 9.1602C11.6625 9.1602 10.8192 8.3202 10.8192 7.2852C10.8192 6.2502 11.6625 5.4102 12.7015 5.4102C13.7406 5.4102 14.5839 6.2502 14.5839 7.2852C14.5839 8.3202 13.7406 9.1602 12.7015 9.1602ZM11.9081 3.07395C10.0117 3.41613 8.53025 5.0577 8.40225 6.95988C8.36461 7.50645 8.42014 8.04363 8.57072 8.53488L2.36837 14.6689C2.2912 14.7439 2.24414 14.8433 2.2319 14.9493L2.00602 16.9583C1.94296 17.5143 2.38343 17.9999 2.94908 17.9999H4.58202C4.70814 17.9999 4.82861 17.9502 4.91708 17.8621L6.26484 16.5289C6.35425 16.4418 6.40414 16.3227 6.40414 16.198V15.0758C6.40414 14.8161 6.6159 14.6071 6.87849 14.6071L7.88837 14.3877C8.27237 14.3043 8.56414 13.9949 8.62249 13.6105L8.75237 12.7536C8.75237 12.4958 8.9632 12.2849 9.22578 12.2849H10.3618C10.487 12.2849 10.6074 12.2361 10.6968 12.1489L11.4611 11.3924C11.9571 11.5414 12.4983 11.5968 13.0498 11.5611C14.9726 11.4346 16.6347 9.97301 16.9839 8.09801C17.5411 5.10082 14.9397 2.52645 11.9081 3.07395Z",
    fill: "#727B7F"
  }));
};